import React from 'react';
import { PrimeIndemnite } from '../../types';
import PrimeHeader from './PrimeHeader';
import PrimeDetails from './PrimeDetails';
import PrimeConfigPanel from './PrimeConfigPanel';

interface PrimeCardProps {
  prime: PrimeIndemnite;
  workTimePercentage: number;
  selectedStatus?: StatusType;
  selectedGrade?: number | null;
  selectedEchelon?: number;
  onToggle: () => void;
  onEditBaseAmount?: () => void;
  onEditReimbursementRate?: () => void;
  onZoneChange?: (zone: number) => void;
  selectedZone?: number | null;
  documentationUrl?: string;
  showDetails: boolean;
  onToggleDetails: () => void;
  currentIndiceMajore?: number | null;
  onIFTDConfigChange?: (config: { dimanchesParMois?: number; joursFeriesTravailles?: string[] }) => void;
  onContagionConfigChange?: (config: { joursTravaillesParAn?: number }) => void;
  onPrimeNuitConfigChange?: (config: { nuitsParMois?: number }) => void;
  onSFTConfigChange?: (config: { nombreEnfants?: number }) => void;
  onTransportBaseAmountChange?: (primeId: string, amount: number) => void;
  onInsalubriteCat2ConfigChange?: (config: { joursTravaillesParMois?: number }) => void;
  onISSConfigChange?: (config: { echelonHistorique?: number; indiceMajoreHistorique?: number }) => void;
  onNBIConfigChange?: (config: { points?: number }) => void;
  onAmountChange?: (amount: number) => boolean;
  isEditingAmount?: boolean;
  onEditAmount?: () => void;
  showCalculationDetails?: boolean;
  onToggleCalculationDetails?: () => void;
  professionId?: string;
}

export default function PrimeCard({
  prime,
  workTimePercentage,
  selectedStatus,
  selectedGrade,
  selectedEchelon,
  onToggle,
  onEditBaseAmount,
  onEditReimbursementRate,
  onZoneChange,
  selectedZone,
  documentationUrl,
  showDetails,
  onToggleDetails,
  currentIndiceMajore,
  onIFTDConfigChange,
  onContagionConfigChange,
  onPrimeNuitConfigChange,
  onSFTConfigChange,
  onTransportBaseAmountChange,
  onInsalubriteCat2ConfigChange,
  onISSConfigChange,
  onNBIConfigChange,
  onAmountChange,
  isEditingAmount,
  onEditAmount,
  showCalculationDetails = false,
  onToggleCalculationDetails,
  professionId
}: PrimeCardProps) {
  console.log('🃏 PrimeCard - insalubrite prime props:', {
    primeId: prime.id,
    onInsalubriteCat2ConfigChange: !!onInsalubriteCat2ConfigChange,
    montantDemiJourneeInsalubrite: prime.montantDemiJourneeInsalubrite,
    insalubriteCat2Config: prime.insalubriteCat2Config
  });

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-shadow">
      <PrimeHeader
        prime={prime}
        workTimePercentage={workTimePercentage}
        selectedStatus={selectedStatus}
        onToggle={onToggle}
        onEditBaseAmount={onEditBaseAmount}
        onEditReimbursementRate={onEditReimbursementRate}
        documentationUrl={documentationUrl}
        showDetails={showDetails}
        onToggleDetailsClick={onToggleDetails}
        onEditAmount={onEditAmount}
        isEditingAmount={isEditingAmount}
      />
      
      {showDetails && (
        <PrimeConfigPanel
          prime={prime}
          currentIndiceMajore={currentIndiceMajore}
          selectedGrade={selectedGrade}
          selectedEchelon={selectedEchelon}
          selectedZone={selectedZone}
          onZoneChange={onZoneChange}
          onIFTDConfigChange={onIFTDConfigChange}
          onISSConfigChange={onISSConfigChange}
          onContagionConfigChange={onContagionConfigChange}
          onPrimeNuitConfigChange={onPrimeNuitConfigChange}
          onSFTConfigChange={onSFTConfigChange}
          onTransportBaseAmountChange={onTransportBaseAmountChange}
          onInsalubriteCat2ConfigChange={onInsalubriteCat2ConfigChange}
          onNBIConfigChange={onNBIConfigChange}
          onAmountChange={onAmountChange}
        />
      )}
      
      {showDetails && (
        <PrimeDetails
          prime={prime}
          currentIndiceMajore={currentIndiceMajore}
          selectedZone={selectedZone}
          documentationUrl={documentationUrl}
          professionId={professionId}
          showCalculationDetails={showCalculationDetails}
          onToggleCalculationDetails={onToggleCalculationDetails}
        />
      )}
      
      {/* CTA vers la documentation officielle - en bas de la prime */}
      {showDetails && (documentationUrl || prime.urlDoc) && (
        <div className="mt-4 flex justify-center">
          <a
            href={documentationUrl || prime.urlDoc}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium shadow-md hover:shadow-lg"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            Documentation officielle
          </a>
        </div>
      )}
    </div>
  );
}